import type { i18n as I18n, TFunction } from 'i18next';

/** Where the language detector reads the user's language from (its default key). */
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

/**
 * The portal's code for a language the browser or storage names: the language without its
 * region (`nb-NO` and `en-US` are `nb` and `en`), and any Norwegian in Bokmål, the portal's only
 * Norwegian (`no` is Chrome's code for it, `nn` is Nynorsk). A regional code kept as the language
 * showed Norwegian text while the picker, matching `nb` exactly, said English.
 */
export function toPortalLanguage(code: string): string {
    const language = code.split(/[-_]/)[0].toLowerCase();
    return language === 'no' || language === 'nn' ? 'nb' : language;
}

/**
 * Switches to the language the user picked and remembers it for the next visit. The detector
 * stores nothing itself (`caches: []` in `initI18n`), so a language a page shows for its own
 * reasons, such as English on the internal pages, is never kept as the user's.
 */
export function chooseLanguage(instance: I18n, language: string): Promise<TFunction> {
    try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    } catch {
        // Private mode or blocked storage: the pick still applies to this visit.
    }
    return instance.changeLanguage(language);
}
